export function numToFixedDp(value: number | string | null | undefined, dp = 2): number {
  if (!value) {
    return 0;
  }

  return +parseFloat(value.toString()).toFixed(dp);
}
